export default {
    root: ({ instance }) => {
        const variant = instance.$attrs.variant;
        if (variant === 'secondary') return 'secondary-tab';
        if (variant === 'tertiary') return 'tertiary-tab';
        return 'primary-tab';
    },
};
